import { useQuery } from '@tanstack/react-query';

export function useProjectsAnalyticsProjectsCreatedReportQuery({
  params = {},
  queryOptions,
}) {
  return useQuery({
    queryKey: ['projectsAnalytics', 'projectsCreatedReports', params],
    queryFn: async () => {
      const response = await axios.post(
        '/projects_analytics/projects_created_reports',
        { projects_created_report: params },
      );

      return response.data;
    },
    ...queryOptions,
  });
}
